import { Grid, withStyles } from "@material-ui/core";
import { primary } from "../../../assets/variables.module.scss";

const DecoratedBox = withStyles({
  root: {
    borderBottom: `solid 4px ${primary}`,
    minHeight: 50,
    paddingBottom: 12,
  },
})(Grid);

export default DecoratedBox;
